/**
 * useViewport — the window width and the breakpoints the Pallas layout uses.
 *
 * Every Pallas style is inline (theme values are read at render time), so
 * CSS media queries are not available; components read these flags instead.
 *
 *   narrow  < 760 px   phones, very small windows: one column, drawers
 *   compact < 1100 px  split-screen laptops, tablets: rail becomes a drawer
 */
import { useEffect, useState } from 'react';

export const BREAKPOINTS = { narrow: 760, compact: 1100 };

function read() {
  const w = typeof window !== 'undefined' ? window.innerWidth : 1440;
  return { width: w, narrow: w < BREAKPOINTS.narrow, compact: w < BREAKPOINTS.compact };
}

export default function useViewport() {
  const [vp, setVp] = useState(read);
  useEffect(() => {
    let frame = null;
    const onResize = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const next = read();
        // Only re-render when a breakpoint flips or the width moved noticeably.
        setVp((prev) => (prev.narrow === next.narrow && prev.compact === next.compact
          && Math.abs(prev.width - next.width) < 24 ? prev : next));
      });
    };
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);
  return vp;
}
